import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EToastPosition } from '../../../../../../projects/common/src/app/enumerables';
import { ITableConfig } from '../../../../../../projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from '../../../../../../projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from '../../../../../../projects/common/src/app/interfaces/table/table-header-params';
import { CacheService, MiningToastService } from '../../../../../../projects/common/src/app/services';
import { LanguageService } from '../../../../../../projects/common/src/app/services/parameters';
import { TableConfigService } from '../../../../../../projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from '../../../../../../projects/common/src/app/services/utils/excel-export.service';
import { excelExportDateFormat } from '../../../../../../projects/common/src/app/services/utils/util.service';
import { environment } from '../../../../../environments/environment';
import { IFilterConfig } from '../../../core/interfaces/filter-config';
import { IOutputFilter } from '../../../core/interfaces/output-filter';
import { GoogleAnalyticsService } from '../../../core/services/google/google-analytics.service';
import { ILayoutConfig } from '../../../layout/interfaces/layout-config';
import { LayoutConfigService } from '../../../layout/services/layout-config.service';
import { IReportOperationalDiscipline } from '../../interfaces/report-operational-discipline';
import { ReportOperationalDisciplineService } from '../../services/report-operational-discipline.service';
import { ReportOperationalDisciplineModalComponent } from './report-operational-discipline-modal/report-operational-discipline-modal.component';

@Component({
  selector: 'app-report-operational-discipline',
  templateUrl: './report-operational-discipline.component.html',
  styleUrls: ['./report-operational-discipline.component.scss'],
})
export class ReportOperationalDisciplineComponent implements OnInit {
  public filterConfig: IFilterConfig;
  public tableConfig: ITableConfig;
  public message: string;
  public systemError: string;
  public params: IOutputFilter;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;
  public dataDiscipline = [];
  public tableData: IReportOperationalDiscipline[];

  constructor(
    private layoutConfigService: LayoutConfigService,
    private tableConfigService: TableConfigService,
    public _operationalDisciplineService: ReportOperationalDisciplineService,
    private _modalService: NgbModal,
    public _excelExportService: ExcelExportService,
    public _toastService: MiningToastService,
    private _cacheService: CacheService,
    private _languageService: LanguageService,
    private _googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.filterConfig = {
      dates: { required: true },
      shift: { required: true },
      machineType: { required: true, multiselect: true },
      machineList: { required: true, multiselect: true },
      cleanButton: true,
    };
    this.disabledExcelBtn = false;
  }

  ngOnInit(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'operational-discipline',
      imageKey: 'report',
      imageType: 'section',
    };
    this.layoutConfigService.setConfig(config);
  }

  public getDataReport(selectedFilters: IOutputFilter): void {
    this.filterConfig.isLoading = true;
    this.params = {
      startDate: selectedFilters.startDate,
      endDate: selectedFilters.endDate,
      shiftId: selectedFilters.shiftId,
      machineId: selectedFilters.machineId,
      companyId: this._cacheService.local('session').user.company.id,
    };
    try {
      this._operationalDisciplineService.getReportOperationalDiscipline(this.params).subscribe({
        next: (response) => {
          if (response && response.data.length > 0) {
            this.tableData = [];

            for (const item of response.data) {
              this.tableData.push({
                date: item.date,
                shiftId: item.shiftId,
                shiftName: item.shiftName,
                machineId: item.machineId,
                machineName: item.machineName,
                operatorFullName: item.operatorFullName,
                loginAt: item.loginAt,
                logoutAt: item.logoutAt,
                lastLocation: item.lastLocation,
                details: 'details',
              });
            }
            this.filterConfig.isLoading = false;
            this.fillTableReport(this.tableData);
            this.systemError = '';
            this.message = '';
          } else {
            this.filterConfig.isLoading = false;
            this.tableConfig = null;
            this.message = this._languageService.message('m034');
          }
        },
      });
    } catch (error) {
      this.systemError = error === 'TimeoutError' ? 'm014' : 'm017';
    }
    const filters = {
      reports: 'report-marine',
    };
    this._googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  public fillTableReport(tableData: any): void {
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns: ['shiftId', 'machineId'],
      replaceColumnName: [
        { prevName: 'loginAt', newName: 'start-session' },
        { prevName: 'logoutAt', newName: 'close-session' },
        { prevName: 'operatorFullName', newName: 'operator' },
        { prevName: 'lastLocation', newName: 'last_location' },
        { prevName: 'details', newName: 'detail' },
      ],
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns: ['shiftId', 'machineId'],
      imageConfig: [
        {
          field: 'details',
          imageType: 'icon',
          imageName: 'watch-detail',
          fieldReplace: false,
          isImageStatus: false,
          imageWidth: '25px',
          imageHeight: '25px',
          margin: '0px 0px 0px 10px',
        },
      ],

      dateConfig: [
        { field: 'date', format: 'date' },
        { field: 'loginAt', format: 'full-time' },
        { field: 'logoutAt', format: 'full-time' },
      ],
      clickConfig: [{ field: 'details', hasCursorPointer: true }],
      isActiveTooltip: false,
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset };
  }

  public viewDetailRow($event): void {
    const formatDate = $event.row[0].value;
    const dateParts = formatDate.split('/');

    let startDateFormated = `${dateParts[2]}-`;
    startDateFormated += `${dateParts[1]}-`;
    startDateFormated += `${dateParts[0]}`;

    const componentRef = this._modalService.open(ReportOperationalDisciplineModalComponent, {
      centered: true,
      size: 'lg',
      windowClass: 'modal-report-operational-discipline',
    });

    const params = {
      shiftId: $event.row[1].value,
      machineId: $event.row[3].value,
      startDate: startDateFormated,
      companyId: this._cacheService.local('session').user.company.id,
    };

    componentRef.componentInstance.params = params;
    componentRef.componentInstance.machineName = $event.row[4].value;
    componentRef.componentInstance.shiftName = $event.row[2].value;
  }

  public downloadExcelFile(): void {
    const paramsExcel = {
      startDate: excelExportDateFormat(this.params.startDate, true),
      endDate: excelExportDateFormat(this.params.endDate, true),
      shiftId: this.params.shiftId,
      machineList: this.params.machineId,
      companyId: this.params.companyId,
    };
    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this._operationalDisciplineService.getReportOperationalDisciplineDocument(paramsExcel).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(
          response,
          'report-operational-discipline',
          { startDate: this.params.startDate, endDate: this.params.endDate },
          null,
          false,
        );
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._toastService.success(null, 'Descarga completado con éxito', {
          position: EToastPosition.bottomCenter,
          closeOnClick: false,
          delay: environment.delayToastSuccess,
        });
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._toastService.error('Error de descarga', 'Verifique la conexión e intente nuevamente', {
          position: EToastPosition.bottomRight,
          closeOnClick: false,
          delay: environment.delayToastError,
        });
      },
    });
  }
}
